if (!customElements.get('nt-offer-countdown')) {
  customElements.define('nt-offer-countdown', class extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.deadline);
      this.timer = this.querySelector('[data-countdown-timer]');
      this.active = this.querySelector('[data-countdown-active]');
      this.ended = this.querySelector('[data-countdown-ended]');
      if (!Number.isFinite(this.deadline) || !this.timer || !this.active || !this.ended) return;
      this.update();
      if (this.deadline > Date.now()) this.interval = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    update() {
      const remaining = this.deadline - Date.now();
      const expired = remaining <= 0;
      this.active.hidden = expired;
      this.ended.hidden = !expired;
      this.timer.hidden = expired;
      if (expired) {
        const offers = this.closest('section')?.querySelector('[data-promotion-offers]');
        if (offers) {
          offers.hidden = true;
          offers.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        }
        window.clearInterval(this.interval);
        return;
      }
      // Recalculate from the fixed deadline, never from session or elapsed timer ticks.
      const totalMinutes = Math.ceil(remaining / 60000);
      if (totalMinutes === this.lastMinutes) return;
      this.lastMinutes = totalMinutes;
      const days = Math.floor(totalMinutes / 1440);
      const hours = Math.floor((totalMinutes % 1440) / 60);
      const minutes = totalMinutes % 60;
      this.querySelector('[data-countdown-days]').textContent = String(days).padStart(2, '0');
      this.querySelector('[data-countdown-hours]').textContent = String(hours).padStart(2, '0');
      this.querySelector('[data-countdown-minutes]').textContent = String(minutes).padStart(2, '0');
      this.timer.setAttribute('aria-label', `${days} giorni, ${hours} ore e ${minutes} minuti alla fine della promozione`);
    }
  });
}
